import { Company } from '@serverfarm/nocd-commons';
import { Maybe } from 'monet';

import { UserRole } from '../../../auth/entities';
import { InProgressState } from '../../redux/actions';

export interface UserProfile {
  userId?: number;
  companyId?: number;
  userName?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  timeZoneRef?: string;
  role: Maybe<UserRole>;
}

export interface UserState {
  isLoggingIn: boolean;
  isLoggedIn: boolean;
  profile: UserProfile;
}

export interface CompaniesListingState extends InProgressState {
  companies: Maybe<Company[]>;
}

export interface ColleaguesListingState extends InProgressState {
  colleagues: Maybe<UserProfile[]>;
}

export enum ServicesAvailable {
  CLIENT = 'client',
  CRAWFISH = 'crawfish',
  WHITE_ANT = 'whiteAnt',
}
export interface ServiceVersion {
  service: ServicesAvailable;
  version: string;
}

export interface ServicesVersionState {
  client: string;
  crawfish: string;
  whiteAnt: string;
}
